import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } }

  connect() {
    setTimeout(() => {
      this.element.classList.add('is-active')
    }, this.delayValue)
  }
}
